import { put, call, takeLatest } from "redux-saga/effects";
import AuthService from "../services/AuthenticationService";
import {
  LOGIN_REQUESTED,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  EMPLOYEE_REQUESTED,
  EMPLOYEE_FAIL,
  EMPLOYEE_SUCCESS,
  EMPLOYEE_ONLINE_INFORMATION_FAIL,
  EMPLOYEE_ONLINE_INFORMATION_REQUESTED,
  EMPLOYEE_ONLINE_INFORMATION_SUCCESS,
  EMPLOYEE_WORKER_SUCCESS,
  EMPLOYEE_WORKER_FAIL,
  EMPLOYEE_WORKER_REQUESTED,
  EMPLOYEE_WORKER_UPDATED_REQUESTED,
  EMPLOYEE_WORKER_UPDATED_SUCCESS,
  EMPLOYEE_WORKER_UPDATED_FAIL,
  PRODUCT_GET_SUCCESS,
  PRODUCT_GET,
  CUSTOMER_GET,
  CUSTOMER_GET_SUCCESS,
  REPORT_GET,
  REPORT_GET_SUCCESS,
  CUSTOMER_REPORT_PORT,
  CUSTOMER_REPORT_PORT_SUCCESS,
  CUSTOMER_STAFF_PORT,
  CUSTOMER_STAFF_PORT_SUCCESS,
  CUSTOMER_STAFF_CUSTOMER_POST,
  CUSTOMER_STAFF_CUSTOMER_SUCCESS,
  LOGIN_HISTORY_POST,
  LOGIN_HISTORY_SUCCESS,
  ACCECPT_NEW_DEVICE_POST,
  ACCECPT_NEW_DEVICE_SUCCESS,
  GET_FILE_FOLDER_TREE,
  GET_FOLDER_TREE_SUCCESS,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_DETAIL_SUCCESS,
  POST_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION,
  GET_NOTIFICATION_DETAIL,
  POST_NOTIFICATION,
  POST_FILE_MANAGER_FOLDER,
  POST_FILE_MANAGER_FOLDER_SUCCESS,
  POST_FILE_MANAGER_UPLOAD,
  POST_FILE_MANAGER_UPLOAD_SUCCESS,
  POST_SETUP_LOGO_SUCCESS,
  GET_CONFIG_LOGO,
  POST_SETUP_LOGO,
  GET_CONFIG_LOGO_SUCCESS,
  GET_CHART_CONFIG_DATABASE_SUCCESS,
  POST_CHART_CONFIG_DATABASE,
  GET_CHART_CONFIG_DATABASE,
  GET_CHART_CONFIG_DATABASE_DETAIL,
  GET_CHART_CONFIG_DATABASE_DETAIL_SUCCESS,
  GET_TEST_CONFIG_DATABASE_SUCCESS,
  GET_TEST_CONFIG_DATABASE,
  DELETE_CHART_CONFIG_DATABASE,
  PUT_CHART_CONFIG_DATABASE,
  POST_PERMISSION_ASSIGN,
  GET_CUSTOMER_GROUP_SUCCESS,
  GET_CUSTOMER_GROUP,
  GET_PRODUCT_CATEGORY,
  GET_PRODUCT_CATEGORY_SUCCESS,
  GET_ORGANIZATION,
  GET_ORGANIZATION_SUCCESS,
  PUT_SET_DATABASE_DEFAULT,
  PUT_SET_DATABASE_DEFAULT_SUCCESS,
  PUT_SET_DATABASE_DEFAULT_FAIL,
  GET_WORKER_INFO_SUCCESS,
  PUT_WORKER_INFO_SUCCESS,
  GET_WORKER_INFO,
  PUT_WORKER_INFO,
  UPDATE_KPI,
  UPDATE_PRODUCT_POSITION,
  UPDATE_PRODUCT_POSITION_SUCCESS,
} from "./actions";
import Storage from "../services/Storage";
import getValue from "lodash/get";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";

function* login(action) {
  try {
    const { data } = yield call(AuthService.login, action.info);
    yield put({ type: LOGIN_SUCCESS, data });
    yield Storage.saveUser(data);
  } catch (error) {
    yield put({ type: LOGIN_FAIL, msg: error });
    yield toast.dismiss("login-error");
    yield toast.error("Đăng nhập không thành công vui lòng thử lại", {
      toastId: "login-error",
    });
  }
}

function* getEmployee(action) {
  try {
    const { data } = yield call(AuthService.getEmployee, action);
    yield put({
      type: EMPLOYEE_SUCCESS,
      employees: getValue(data, "employees", []),
    });
  } catch (error) {
    yield put({ type: EMPLOYEE_FAIL, msg: error });
  }
}

function* getOnlineInformation(action) {
  try {
    yield toast.dismiss("toast-id");
    const { data } = yield call(AuthService.onlineInformation, action);
    if (isEmpty(getValue(data, "employees", []))) {
      yield toast.info("Không có dữ liệu đi tuyến", {
        position: toast.POSITION.TOP_RIGHT,
        toastId: "toast-id",
      });
    }

    const onlineInformation = getValue(data, "employees", []);

    let boundMap;
    if (action.map) {
      boundMap = new action.map.maps.LatLngBounds();
    }
    if (!isEmpty(onlineInformation) && boundMap) {
      for (let index = 0; index < onlineInformation.length; index++) {
        const item = onlineInformation[index];
        boundMap.extend({ lat: item.Latitude, lng: item.Longitude });
      }
    }

    yield put({
      type: EMPLOYEE_ONLINE_INFORMATION_SUCCESS,
      onlineInformation,
      boundMap,
    });
  } catch (error) {
    yield put({ type: EMPLOYEE_ONLINE_INFORMATION_FAIL, msg: error });
  }
}

function* updateProductPosition(action) {
  try {
    yield call(AuthService.updateProductPosition, action);
    yield put({
      type: EMPLOYEE_WORKER_REQUESTED,
      token: action.token,
      Id: action.data.AccountObjectCode,
      isKeepData: true,
    });
    yield put({
      type: UPDATE_PRODUCT_POSITION_SUCCESS,
    });

    yield toast.success("Cập nhật vị trí sản phẩm thành công", {
      position: toast.POSITION.TOP_RIGHT,
      toastId: "updateProductPosition",
    });
  }
  catch (error) {
    console.error("updateProductPosition error", error);
    yield toast.error("Cập nhật vị trí sản phẩm không thành công vui lòng thử lại", {
      position: toast.POSITION.TOP_RIGHT,
      toastId: "updateProductPosition",
    });
  }
}

function* getWorkers(action) {
  try {
    yield toast.dismiss("toast-id");
    const { data } = yield call(AuthService.workers, action.Id, action.token);
    yield put({
      type: EMPLOYEE_WORKER_SUCCESS,
      workers: {
        members: getValue(data, "members", []),
        provinces: getValue(data, "provinces", []),
        permissions: getValue(data, "permissions", []),
        // sort by sortOrder
        products: getValue(data, "products", []).sort((a, b) => {
          return a.sortOrder - b.sortOrder;
        }),
        manageFile: getValue(data, "manageFile", []),
        data: getValue(data, "data"),
        createFolder: getValue(data, "createFolder", []),
        deleteFolder: getValue(data, "deleteFolder", []),
        editFolder: getValue(data, "editFolder", []),
        readFolder: getValue(data, "readFolder", []),
      },
    });
  } catch (error) {
    yield put({ type: EMPLOYEE_WORKER_FAIL, msg: error });
  }
}

function* updateWorkers(action) {
  try {
    yield toast.dismiss("updateWorkers");
    yield call(AuthService.setPassword, action.playground, action.token);
    const { data } = yield call(
      AuthService.updateWorkers,
      action.playground,
      action.token
    );
    yield toast.success("Cập nhật thông tin thành công!", {
      position: toast.POSITION.TOP_RIGHT,
      toastId: "updateWorkers",
    });
    yield put({
      type: EMPLOYEE_WORKER_UPDATED_SUCCESS,
      workers: {
        members: getValue(data, "members", []),
        manageFile: getValue(data, "manageFile", []),
        // sort by sortOrder
        products: getValue(data, "products", []).sort((a, b) => {
          return a.sortOrder - b.sortOrder;
        }),
        provinces: getValue(data, "provinces", []),
        createFolder: getValue(data, "createFolder", []),
        deleteFolder: getValue(data, "deleteFolder", []),
        editFolder: getValue(data, "editFolder", []),
        readFolder: getValue(data, "readFolder", []),
      },
      infoUpdate: action.playground,
      isUpdateWork: true,
    });
  } catch (error) {
    yield toast.error("Cập nhật thông tin không thành công vui lòng thử lại", {
      position: toast.POSITION.TOP_RIGHT,
      toastId: "updateWorkers",
    });
    yield put({ type: EMPLOYEE_WORKER_UPDATED_FAIL, msg: error });
  }
}

function* getCustomer(action) {
  try {
    const { data } = yield call(AuthService.getCustomer, action);
    yield put({
      type: CUSTOMER_GET_SUCCESS,
      dataCustomer: getValue(data, "data", []),
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}
function* getProduct(action) {
  try {
    const { data } = yield call(AuthService.getProduct, action);
    yield put({
      type: PRODUCT_GET_SUCCESS,
      dataProduct: getValue(data, "data", []),
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}
function* getDataReport(action) {
  try {
    const {
      data: { data = [] },
    } = yield call(AuthService.getDataReport, action);
    yield put({ type: REPORT_GET_SUCCESS, dataReport: data || [] });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* postReportCustomer(action) {
  try {
    const {
      data: { data = [] },
    } = yield call(AuthService.getDataReport, action);
    yield put({
      type: CUSTOMER_REPORT_PORT_SUCCESS,
      dataReportCustomer: data || [],
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* postReportStaff(action) {
  try {
    const {
      data: { data = [] },
    } = yield call(AuthService.getDataReport, action);
    yield put({
      type: CUSTOMER_STAFF_PORT_SUCCESS,
      dataReportStaff: data || [],
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* postOderList(action) {
  try {
    const { data } = yield call(AuthService.getDataReport, action, true);
    const dataReturns = (data?.saleAmountReturn || []).map((item) => ({
      ...item,
      TotalSaleAmountReturn: parseInt(item.TotalSaleAmount) || 0,
    }));
    const newData = [...(data?.data || []), ...dataReturns].sort((a, b) => {
      return new Date(b.ngayXuatBan) - new Date(a.ngayXuatBan);
    });

    const TotalDiscountAmount =
      (data?.totalSalesDiscountAmount || 0) -
      (data?.totalSaleDiscountAmountReturn || 0);
    const TotalSaleAmount = getValue(data, "totalSalesAmount", 0);
    const TotalSaleAmountReturn = getValue(data, "totalSaleAmountReturn", 0);

    yield put({
      type: CUSTOMER_STAFF_CUSTOMER_SUCCESS,
      reportStaffCustomer: newData || [],
      sumReportStaffCustomer: {
        TotalSaleAmount,
        TotalSaleAmountReturn,
        TotalDiscountAmount,
        Sale: TotalSaleAmount - TotalDiscountAmount - TotalSaleAmountReturn,
      },
    });
  } catch (error) {
    console.log(error);
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* postLoginHistory(action) {
  try {
    const {
      data: { data, pageInfo },
    } = yield call(AuthService.postLoginHistory, action);

    yield put({
      type: LOGIN_HISTORY_SUCCESS,
      loginHistory: { data, pageInfo },
    });
  } catch (error) {
    console.log("postLoginHistory error", error);
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* postAcceptNewDevice(action) {
  try {
    yield call(AuthService.accecptNewDevice, action);

    yield put({
      type: ACCECPT_NEW_DEVICE_SUCCESS,
    });
    yield toast.success("Cho phép thay đổi thiết bị thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    console.log("postAcceptNewDevice error", error);
    yield toast.error("Cho phép thay đổi thiết bị không thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* getFileFolderTree(action) {
  try {
    const {
      data: { data = [] },
    } = yield call(AuthService.getFileFolderTree, action);

    yield put({
      type: GET_FOLDER_TREE_SUCCESS,
      folderTree: data,
    });
  } catch (error) {
    console.log("getFileFolderTree error", error);
    // yield toast.error(error?.data?.errors?.[0]?.message || 'Lấy thông tin không thành công', {
    //   position: toast.POSITION.TOP_RIGHT,
    // });
  }
}

function* getNotification(action) {
  try {
    const {
      data: { data, pageInfo },
    } = yield call(AuthService.getNotification, action);
    yield put({
      type: GET_NOTIFICATION_SUCCESS,
      notification: { data, pageInfo },
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* getNotificationDetail(action) {
  try {
    const { data } = yield call(AuthService.getNotificationDetail, action);
    yield put({
      type: GET_NOTIFICATION_DETAIL_SUCCESS,
      notificationDetail: getValue(data, "data", []),
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* postNotification(action) {
  try {
    yield call(AuthService.postNotification, action);
    yield put({
      type: POST_NOTIFICATION_SUCCESS,
    });
    // Gửi lại yêu cầu để lấy danh sách thông báo mới nhất
    yield getNotification({
      token: action.token,
      data: {
        page: 1,
        limit: 10,
      },
    });
    yield toast.success("Gửi thông báo thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    yield toast.error("Gửi thông báo không thành công vui lòng thử lại", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* postFileManagerFolder(action) {
  try {
    yield call(AuthService.fileManagerFolder, action);
    yield put({
      type: POST_FILE_MANAGER_FOLDER_SUCCESS,
    });
    yield put({
      type: GET_FILE_FOLDER_TREE,
    });
    yield toast.success("Thêm thông tin thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    yield toast.error("Thêm thông tin không thành công vui lòng thử lại", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* fileManagerUpload(action) {
  try {
    yield call(AuthService.fileManagerUpload, action);
    yield put({
      type: POST_FILE_MANAGER_UPLOAD_SUCCESS,
    });
    yield put({
      type: GET_FILE_FOLDER_TREE,
    });
    yield toast.success("Tải file lên thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    yield toast.error(
      error?.data?.message || "Tải file lên không thành công vui lòng thử lại",
      {
        position: toast.POSITION.TOP_RIGHT,
      }
    );
  }
}

function* getSetupLogo(action) {
  try {
    const { data } = yield call(AuthService.getSetupLogo, action);
    console.log("getSetupLogo", data);
    yield put({
      type: GET_CONFIG_LOGO_SUCCESS,
      configLogo: data?.data || {},
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}
function* postSetupLogo(action) {
  try {
    yield call(AuthService.setupLogo, action);
    yield put({
      type: POST_SETUP_LOGO_SUCCESS,
    });
    yield put({
      type: GET_CONFIG_LOGO,
    });
    yield toast.success("Cập nhật cấu hình thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    yield toast.error("Cập nhật cấu hình không thành công vui lòng thử lại", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* getChartConfigDatabase(action) {
  try {
    const { data } = yield call(AuthService.getChartConfigDatabase, action);
    yield put({
      type: GET_CHART_CONFIG_DATABASE_SUCCESS,
      chartConfigDatabase: data || [],
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* postChartConfigDatabase(action) {
  try {
    yield call(AuthService.testConnect, action);
    yield call(AuthService.postChartConfigDatabase, action);
    yield put({
      type: GET_CHART_CONFIG_DATABASE,
    });
    yield toast.success("Cập nhật cấu hình cơ sở dữ liệu thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    yield toast.error(
      error?.data?.message ||
        "Cập nhật cấu hình cơ sở dữ liệu không thành công vui lòng thử lại",
      {
        position: toast.POSITION.TOP_RIGHT,
      }
    );
  }
}

function* putChartConfigDatabase(action) {
  try {
    yield call(AuthService.testConnect, action);
    yield call(AuthService.putChartConfigDatabase, action);
    yield put({
      type: GET_CHART_CONFIG_DATABASE,
    });
    yield toast.success("Cập nhật cấu hình cơ sở dữ liệu thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    yield toast.error(
      error?.data?.message ||
        "Cập nhật cấu hình cơ sở dữ liệu không thành công vui lòng thử lại",
      {
        position: toast.POSITION.TOP_RIGHT,
      }
    );
  }
}

function* deleteChartConfigDatabase(action) {
  try {
    yield call(AuthService.deleteChartConfigDatabase, action);
    yield put({
      type: GET_CHART_CONFIG_DATABASE,
    });
    yield toast.success("Xóa cấu hình cơ sở dữ liệu thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    console.log("deleteChartConfigDatabase error", error);
    yield toast.error(
      "Xóa cấu hình cơ sở dữ liệu không thành công vui lòng thử lại",
      {
        position: toast.POSITION.TOP_RIGHT,
      }
    );
  }
}

function* setDatabaseDefault(action) {
  try {
    yield call(AuthService.setDatabaseDefault, action);
    yield put({
      type: PUT_SET_DATABASE_DEFAULT_SUCCESS,
    });
    yield put({
      type: GET_CHART_CONFIG_DATABASE,
    });
    yield toast.success("Cài đặt cấu hình cơ sở dữ liệu thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    yield put({
      type: PUT_SET_DATABASE_DEFAULT_FAIL,
    });
    yield toast.error(
      "Cài đặt cấu hình cơ sở dữ liệu không thành công vui lòng thử lại",
      {
        position: toast.POSITION.TOP_RIGHT,
      }
    );
  }
}

function* getChartConfigDatabaseDetail(action) {
  try {
    const { data } = yield call(
      AuthService.getChartConfigDatabaseDetail,
      action
    );
    yield put({
      type: GET_CHART_CONFIG_DATABASE_DETAIL_SUCCESS,
      chartConfigDatabaseDetail: data || [],
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

function* testConnect(action) {
  try {
    const { data } = yield call(AuthService.testConnect, action);
    yield put({
      type: GET_TEST_CONFIG_DATABASE_SUCCESS,
      chartConfigDatabaseDetail: data || [],
    });
    console.log("testConnect", data);
    yield toast.success("Kiểm tra kết nối thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    yield toast.error(
      error?.data?.message ||
        "Kiểm tra kết nối không thành công vui lòng thử lại",
      {
        position: toast.POSITION.TOP_RIGHT,
      }
    );
  }
}

function* permissionAssign(action) {
  try {
    const { data } = yield call(AuthService.permissionAssign, action);
    // yield put({
    //   type: GET_TEST_CONFIG_DATABASE_SUCCESS,
    //   chartConfigDatabaseDetail: data || [],
    // });
    console.log("permissionAssign", data);
    yield toast.success("Cập nhật quyền thành công", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } catch (error) {
    yield toast.error(
      error?.data?.message ||
        "Kiểm tra kết nối không thành công vui lòng thử lại",
      {
        position: toast.POSITION.TOP_RIGHT,
      }
    );
  }
}

export function* customerGroups(action) {
  try {
    const { data } = yield call(AuthService.getCustomerGroup, action);

    yield put({
      type: GET_CUSTOMER_GROUP_SUCCESS,
      customerGroups: data?.data || [],
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

export function* getproductCategory(action) {
  try {
    const { data } = yield call(AuthService.getproductCategory, action);
    yield put({
      type: GET_PRODUCT_CATEGORY_SUCCESS,
      productCategories: data?.data || [],
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

export function* getOrganization(action) {
  try {
    const { data } = yield call(AuthService.getOrganization, action);
    yield put({
      type: GET_ORGANIZATION_SUCCESS,
      organization: data?.data || [],
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

export function* getWorkerInfo(action) {
  try {
    const { data } = yield call(AuthService.getWorkerInfo, action);

    yield put({
      type: UPDATE_KPI,
      kpi: {
        Amount: getValue(data, "targetByMonth.Amount", 0),
        TotalOrder: getValue(data, "targetByMonth.TotalOrder", 0),
        TotalNewCustomer: getValue(data, "targetByMonth.TotalNewCustomer", 0),
        TotalCustomerHaveOrder: getValue(
          data,
          "targetByMonth.TotalCustomerHaveOrder",
          0
        ),
      },
    });
    yield put({
      type: GET_WORKER_INFO_SUCCESS,
      workerInfo: data || {},
      groupKpi: getValue(data, "totalTargetByMonth", {}),
      achieved: getValue(data, "achieved", {}),
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

export function* updateWorkerKpi(action) {
  try {
    yield call(AuthService.updateWorkerKpi, action);
    yield put({
      type: PUT_WORKER_INFO_SUCCESS,
    });
  } catch (error) {
    yield toast.error("Có lỗi xảy ra vui lòng refresh trình duyệt", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }
}

export default function* () {
  yield takeLatest(LOGIN_REQUESTED, login);
  yield takeLatest(EMPLOYEE_REQUESTED, getEmployee);
  yield takeLatest(EMPLOYEE_ONLINE_INFORMATION_REQUESTED, getOnlineInformation);
  yield takeLatest(EMPLOYEE_WORKER_REQUESTED, getWorkers);
  yield takeLatest(EMPLOYEE_WORKER_UPDATED_REQUESTED, updateWorkers);
  yield takeLatest(PRODUCT_GET, getProduct);
  yield takeLatest(CUSTOMER_GET, getCustomer);
  yield takeLatest(REPORT_GET, getDataReport);
  yield takeLatest(CUSTOMER_REPORT_PORT, postReportCustomer);
  yield takeLatest(CUSTOMER_STAFF_PORT, postReportStaff);
  yield takeLatest(CUSTOMER_STAFF_CUSTOMER_POST, postOderList);
  yield takeLatest(LOGIN_HISTORY_POST, postLoginHistory);
  yield takeLatest(ACCECPT_NEW_DEVICE_POST, postAcceptNewDevice);
  yield takeLatest(GET_FILE_FOLDER_TREE, getFileFolderTree);

  yield takeLatest(GET_NOTIFICATION, getNotification);
  yield takeLatest(GET_NOTIFICATION_DETAIL, getNotificationDetail);
  yield takeLatest(POST_NOTIFICATION, postNotification);
  yield takeLatest(POST_FILE_MANAGER_FOLDER, postFileManagerFolder);
  yield takeLatest(POST_FILE_MANAGER_UPLOAD, fileManagerUpload);
  yield takeLatest(GET_CONFIG_LOGO, getSetupLogo);
  yield takeLatest(POST_SETUP_LOGO, postSetupLogo);

  yield takeLatest(GET_CHART_CONFIG_DATABASE, getChartConfigDatabase);
  yield takeLatest(POST_CHART_CONFIG_DATABASE, postChartConfigDatabase);
  yield takeLatest(PUT_CHART_CONFIG_DATABASE, putChartConfigDatabase);
  yield takeLatest(DELETE_CHART_CONFIG_DATABASE, deleteChartConfigDatabase);
  yield takeLatest(
    GET_CHART_CONFIG_DATABASE_DETAIL,
    getChartConfigDatabaseDetail
  );
  yield takeLatest(GET_TEST_CONFIG_DATABASE, testConnect);

  yield takeLatest(POST_PERMISSION_ASSIGN, permissionAssign);
  yield takeLatest(GET_CUSTOMER_GROUP, customerGroups);
  yield takeLatest(GET_PRODUCT_CATEGORY, getproductCategory);
  yield takeLatest(GET_ORGANIZATION, getOrganization);
  yield takeLatest(PUT_SET_DATABASE_DEFAULT, setDatabaseDefault);

  yield takeLatest(GET_WORKER_INFO, getWorkerInfo);
  yield takeLatest(PUT_WORKER_INFO, updateWorkerKpi);
  yield takeLatest(UPDATE_PRODUCT_POSITION, updateProductPosition);
}
